import type * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAiReportsPricingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAiReportsPricingQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly subscription: { readonly __typename?: 'YalperSubscription', readonly tariffDetails?: { readonly __typename?: 'BillingTariff', readonly aiReportsUnitPrice: number } | null } } | null };


export const GetAiReportsPricingDocument = gql`
    query GetAiReportsPricing {
  currentUser {
    subscription {
      tariffDetails {
        aiReportsUnitPrice
      }
    }
  }
}
    `;

/**
 * __useGetAiReportsPricingQuery__
 *
 * To run a query within a React component, call `useGetAiReportsPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiReportsPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiReportsPricingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiReportsPricingQuery(baseOptions?: Apollo.QueryHookOptions<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>(GetAiReportsPricingDocument, options);
      }
export function useGetAiReportsPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>(GetAiReportsPricingDocument, options);
        }
export function useGetAiReportsPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>(GetAiReportsPricingDocument, options);
        }
export type GetAiReportsPricingQueryHookResult = ReturnType<typeof useGetAiReportsPricingQuery>;
export type GetAiReportsPricingLazyQueryHookResult = ReturnType<typeof useGetAiReportsPricingLazyQuery>;
export type GetAiReportsPricingSuspenseQueryHookResult = ReturnType<typeof useGetAiReportsPricingSuspenseQuery>;
export type GetAiReportsPricingQueryResult = Apollo.QueryResult<GetAiReportsPricingQueryPage, GetAiReportsPricingQueryVariables>;